import { Card, Divider, Modal, Table } from "antd";
import React, { useEffect, useState } from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import "../../../../App.css";
import {
  RightCircleOutlined,
  LeftCircleOutlined,
  BarChartOutlined,
  PieChartOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  SetIncidentData,
  fetchIncidentData,
  fetchIncidentCodes,
  apiCallStatus,
} from "../actions/maintenanceDashboardService";
import {
  incidentBarlabels,
  incidentBarStatusData,
  IncidentDoughnutStatusData,
  barOptions,
  doughnutOptions,
  Incidentcolumns,
  doughnutChartCenterValue,
  renderStatusData,
  filterData,
  handleIncidentChartClick,
  formatDataWithCodes,
  calculateIncidentScore,
} from "../constant/maintenanceConstantData";
import { IncidentChildComponent } from "../maintenanceCommonComponent";

const MaintenanceIncidentCard = ({
  searchedItem,
  handleChevronRightClick,
  showMaintenanceIncidents,
  setShowMaintenanceIncidents,
}) => {
  const [toggleCard, setToggleCard] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const [mappedCodes, setMappedCodes] = useState({});
  const [PageState, setPageState] = useState({
    currentPage: 1,
    pageSize: 10,
  });
  const dispatch = useDispatch();
  const [incidentData, setIncidentData] = useState({
    incidentChartData: null,
    incidentTotalCount: 0,
    incidentModalData: null,
    incidentCodes: null,
  });
  const maintenanceDashboardList = useSelector((state) => state?.maintenanceDashboardList);

  useEffect(() => {
    // Update state when data becomes available
    if (maintenanceDashboardList) {
      setIncidentData({
        incidentChartData: maintenanceDashboardList?.IncidentChartData ,
        incidentTotalCount: maintenanceDashboardList?.IncidentTotalCount ,
        incidentModalData: maintenanceDashboardList?.IncidentModalData ,
        incidentCodes: maintenanceDashboardList?.IncidentCodes ,
      });
    }
  }, [maintenanceDashboardList]);
  // const {
  //   IncidentChartData: incidentChartData,
  //   IncidentTotalCount: incidentTotalCount,
  //   IncidentModalData: incidentModalData,
  //   IncidentCodes: incidentCodes,
  // } = useSelector((state) => state?.maintenanceDashboardList);
  const toggleChartType = () => {
    setToggleCard(!toggleCard);
  };

  //these are count
  const [openData, setOpenData] = useState(Array(0).fill(3));
  const [closedData, setCloseData] = useState(Array(0).fill(3));
  const [levelOneDataCount, setLevelOneDataCount] = useState(0);
  const [levelTwoDataCount, setLevelTwoDataCount] = useState(0);
  const [levelThreeDataCount, setLevelThreeDataCount] = useState(0);
  const [levelFourDataCount, setLevelFourDataCount] = useState(0);

  const [incidentTotalCloseNcCount, setIncidentTotalCloseNcCount] = useState(0);
  const [inncidentTotalOpenNcCount, setIncidentTotalOpenNcCount] = useState(0);

  const labels = IncidentDoughnutStatusData.map((item) => item.status);
  const backgroundColors = IncidentDoughnutStatusData.map((item) => item.color);
  const incidentBarData = {
    labels: incidentBarlabels,
    datasets: [
      {
        label: incidentBarStatusData[0].status,
        data: openData,
        backgroundColor: incidentBarStatusData[0].color,
      },
      {
        label: incidentBarStatusData[1].status,
        data: closedData,
        backgroundColor: incidentBarStatusData[1].color,
      },
    ],
  };

  const incidentBarOptions = {
    ...barOptions,
    scales: {
      x: {
        stacked: true,
        grid: {
          drawBorder: false,
          display: false,
        },
      },
      y: {
        stacked: true,
        ticks: {
          beginAtZero: true,
        },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
    },
  };

  const incidenDoughnutData = {
    labels: labels,
    datasets: [
      {
        // label: "# of Votes",
        data: [
          levelOneDataCount,
          levelTwoDataCount,
          levelThreeDataCount,
          levelFourDataCount,
        ],
        backgroundColor: backgroundColors,
        // borderColor: ["white", "white", "white", "white"],
        borderWidth: 1,
      },
    ],
  };

  const incidentDoughnutOptions = {
    ...doughnutOptions,

    onClick: (event, chartElements) =>
      handleIncidentChartClick({
        event,
        chartElements,
        incidenDoughnutData,
        setSelectedLabel,
        setModalVisible,
        searchedItem,
        dispatch,
        fetchIncidentData,
        mappedCodes,
      }),
  };

  const handleModalClose = () => {
    setModalVisible(false);
    setPageState((prevState) => ({ ...prevState, currentPage: 1 }));
  };
  const pagination = {
    pageSize: PageState.pageSize, // Set the number of items per page
    current: PageState.currentPage, // Set the current page
    onChange: (page, pageSize) => {
      // Handle page change here, e.g., fetch and display data based on the new page and pageSize
      console.log(`Page: ${page}, PageSize: ${pageSize}`);
      setPageState({ currentPage: page, pageSize: pageSize });
    },
  };
  useEffect(() => {
    dispatch(fetchIncidentCodes());
  }, []);
  useEffect(() => {
    dispatch(
      SetIncidentData({
        incidentBarData,
        incidenDoughnutData,
      })
    );
  }, [
    levelOneDataCount,
    levelTwoDataCount,
    levelThreeDataCount,
    levelFourDataCount,
  ]);
  useEffect(() => {
    if (incidentData?.incidentChartData && incidentData?.incidentCodes) {
      const formattedIncidentData = formatDataWithCodes(
        incidentData?.incidentCodes,
        incidentData?.incidentChartData,
        setMappedCodes
      );
      if (!formattedIncidentData?.length) return;
      const levelOneOpen = filterData(
        formattedIncidentData,
        "Level 1",
        "Open"
      )[0];
      const levelOneClose = filterData(
        formattedIncidentData,
        "Level 1",
        "Close"
      )[0];
      const levelTwoOpen = filterData(
        formattedIncidentData,
        "Level 2",
        "Open"
      )[0];
      const levelTwoClose = filterData(
        formattedIncidentData,
        "Level 2",
        "Close"
      )[0];
      const levelThreeOpen = filterData(
        formattedIncidentData,
        "Level 3",
        "Open"
      )[0];
      const levelThreeClose = filterData(
        formattedIncidentData,
        "Level 3",
        "Close"
      )[0];
      const levelFourOpen = filterData(
        formattedIncidentData,
        "Level 4",
        "Open"
      )[0];
      const levelFourClose = filterData(
        formattedIncidentData,
        "Level 4",
        "Close"
      )[0];
      setIncidentTotalCloseNcCount(
        levelOneClose + levelTwoClose + levelThreeClose + levelFourClose
      );
      setIncidentTotalOpenNcCount(
        levelOneOpen + levelTwoOpen + levelThreeOpen + levelFourOpen
      );
      setLevelOneDataCount(levelOneOpen + levelOneClose);
      setLevelTwoDataCount(levelTwoOpen + levelTwoClose);
      setLevelThreeDataCount(levelThreeOpen + levelThreeClose);
      setLevelFourDataCount(levelFourOpen + levelFourClose);

      setOpenData([levelOneOpen, levelTwoOpen, levelThreeOpen, levelFourOpen]);
      setCloseData([
        levelOneClose,
        levelTwoClose,
        levelThreeClose,
        levelFourClose,
      ]);

      //set incident score
      const incidentScore = calculateIncidentScore(
        levelOneClose,
        levelTwoClose,
        levelThreeClose,
        levelFourClose,
        incidentData?.incidentTotalCount
      );

      dispatch(apiCallStatus({ incidentScore }));
    }
  }, [incidentData?.incidentChartData, incidentData?.incidentCodes]);

  const currentYear = searchedItem?.currentYear ?? new Date().getFullYear();
  const incidentTextCenter = doughnutChartCenterValue("Total incidents");
  return (
    <>
      <Modal
        title={`${selectedLabel} Incidents`}
        open={modalVisible}
        // centered={true}
        onCancel={handleModalClose}
        width={1000}
        className="maintenance-incidents-modal"
        footer={[
          <button
            type="button"
            onClick={handleModalClose}
            className="btn muted-button  deca-btn-orange"
          >
            Close
          </button>,
        ]}
      >
        <div className="m-table__main">
          <div className="m-table__responsive large-width">
            <Table
              columns={Incidentcolumns}
              dataSource={incidentData?.incidentModalData}
              pagination={pagination}
            />
          </div>
        </div>
      </Modal>
      <Card
        className={showMaintenanceIncidents ? "first-card-class" : "card-class"}
      >
        <div className={showMaintenanceIncidents ? "card-main-div" : ""}>
          <div className="card-first-div">
            <div className="maintenance-incidents-heading-div">
              <h3 className="card-heading">Maintenance Incidents</h3>
              {toggleCard ? (
                <BarChartOutlined onClick={toggleChartType} />
              ) : (
                <PieChartOutlined onClick={toggleChartType} />
              )}
            </div>

            <div className="chart-main-div">
              <div className="doughnut-chart-div">
                {toggleCard ? (
                  <Doughnut
                    data={incidenDoughnutData}
                    options={incidentDoughnutOptions}
                    plugins={[incidentTextCenter]}
                  />
                ) : (
                  <Bar data={incidentBarData} options={incidentBarOptions} />
                )}
              </div>

              <div className="asset-health-score-level">
                {toggleCard
                  ? renderStatusData(IncidentDoughnutStatusData)
                  : renderStatusData(incidentBarStatusData)}
              </div>
            </div>
            <div className="maintenance-incidents-audit-icon-div">
              {showMaintenanceIncidents ? (
                ""
              ) : (
                <span
                  onClick={() => {
                    handleChevronRightClick("maintenance-incidents");
                  }}
                  className="right-circle-outlined-icon"
                >
                  <RightCircleOutlined />
                </span>
              )}
            </div>
          </div>
          {showMaintenanceIncidents && (
            <div className="showcard-card-class">
              <div className="showcard-card-class-main-div">
                <IncidentChildComponent
                  currentYear={currentYear}
                  inncidentTotalOpenNcCount={inncidentTotalOpenNcCount}
                  incidentTotalCloseNcCount={incidentTotalCloseNcCount}
                  incidentTotalCount={incidentData?.incidentTotalCount}
                />

                <Divider />
              </div>
              <div className="third-party-audit-icon-div">
                <span
                  className="left-circle-outlined-icon"
                  onClick={() =>
                    setShowMaintenanceIncidents(!showMaintenanceIncidents)
                  }
                >
                  <LeftCircleOutlined />
                </span>
              </div>
            </div>
          )}
        </div>
      </Card>
    </>
  );
};

export default MaintenanceIncidentCard;
